"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var finders_1 = require("../util/finders");
var utils_1 = require("../util/utils");
var index_1 = require("../index");
function mapPaths(obj, json, ignorePaths) {
    if (json === void 0) { json = {}; }
    if (ignorePaths === void 0) { ignorePaths = ''; }
    return lodash_1.reduce(finders_1.findAllDotPaths(obj), function (acc, path) {
        var matchingFields = finders_1.findMatchingFields(path, json, ignorePaths);
        if (matchingFields.length) {
            acc[path] = matchingFields;
        }
        return acc;
    }, {});
}
exports.mapPaths = mapPaths;
function mutateDotPathOptions(key) {
    return lodash_1.uniq([
        lodash_1.camelCase(key),
        lodash_1.snakeCase(key),
        lodash_1.kebabCase(key)
    ]);
}
exports.mutateDotPathOptions = mutateDotPathOptions;
function generateDefaultGetters(config, key) {
    var _a;
    var configKey = (!config[key].dotPaths) ?
        Object.assign(config[key], {
            dotPaths: mutateDotPathOptions(key)
        }) : config[key];
    return Object.assign(config, (_a = {},
        _a[key] = configKey,
        _a));
}
exports.generateDefaultGetters = generateDefaultGetters;
function generateDefaultGettersForPartialConfig(config) {
    return lodash_1.reduce(Object.keys(config), function (configCC, key) {
        return Object.assign(configCC, generateDefaultGetters(configCC, key));
    }, config);
}
exports.generateDefaultGettersForPartialConfig = generateDefaultGettersForPartialConfig;
/**
 *
 * @param obj Object to map JSON to
 * @param json Json in the shape of what you expect OR get
 * @param ignorePaths DotPaths that are for some reason not to be used
 * @param optionalPartialConfig A partial config that may define getters/paths
 *                                      for a key that needs special treatment
 */
function buildConfig(obj, json, ignorePaths, optionalPartialConfig, mapUntypedObjects) {
    if (json === void 0) { json = {}; }
    if (ignorePaths === void 0) { ignorePaths = ''; }
    if (optionalPartialConfig === void 0) { optionalPartialConfig = {}; }
    if (mapUntypedObjects === void 0) { mapUntypedObjects = false; }
    var map = mapPaths(obj, json, ignorePaths);
    return lodash_1.merge(lodash_1.reduce(Object.keys(map), function (acc, path) {
        // Don't expand objects if we don't have them in
        // the defined object unless the user asks
        var getter = finders_1.findAppropriateGetter(obj, path);
        if (getter !== index_1.objectOr || mapUntypedObjects) {
            acc[path] = {
                getter: getter,
                dotPaths: map[path]
            };
        }
        return acc;
    }, {}), generateDefaultGettersForPartialConfig(optionalPartialConfig));
}
exports.buildConfig = buildConfig;
var shouldStomp = function (stomper, key) {
    if (key === void 0) { key = ''; }
    return (lodash_1.isArray(stomper)) ? !!stomper.find(function (s) { return s === key; }) : stomper;
};
var getDotPathPrefix = function (value) {
    return value.substring(0, value.lastIndexOf('.'));
};
function setKeys(obj, json, config, stomp) {
    if (json === void 0) { json = {}; }
    Object.keys(config).forEach(function (key) {
        var _a = config[key], dotPaths = _a.dotPaths, getter = _a.getter, decorators = _a.decorators;
        if (!getter) {
            index_1.Log.warn("No appropriate getter found for field " + key + ", " +
                ("there was no default value " + getter));
            return;
        }
        var dotPath;
        if (Array.isArray(dotPaths)) {
            if (key.indexOf('.') > 0) {
                var dotPathPrefix_1 = getDotPathPrefix(key);
                dotPath = dotPaths.filter(function (_) {
                    return getDotPathPrefix(_) === dotPathPrefix_1;
                })[0];
            }
            dotPath = dotPath || dotPaths.concat(key);
        }
        else
            dotPath = dotPaths;
        try {
            var value = getter(json, dotPath, decorators);
            utils_1.setOnPath(obj, key, value, shouldStomp(stomp));
        }
        catch (error) {
            index_1.Log.error(error);
        }
    });
    return obj;
}
exports.setKeys = setKeys;
/**
 *
 * @param obj Your target object
 * @param config A GetterConfig that knows how to find values in the JSON
 * @param json A JSON object that is 'like' what you want your final object to be
 */
function applyConfig(obj, config, json, stomp) {
    if (json === void 0) { json = {}; }
    if (stomp === void 0) { stomp = false; }
    return setKeys(obj, json, config, stomp);
}
exports.applyConfig = applyConfig;
exports.forceApplyConfig = function (obj, config, json, stomp) {
    if (json === void 0) { json = {}; }
    return applyConfig(obj, config, json, false);
};
//# sourceMappingURL=configBuilder.js.map